import xhr from '../utils/fetch';

const booktrail = async (data: any) => {
  return await xhr({
    url: '/b/addbooktrail',
    method: 'POST',
    body: data
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getbooktraildata = async () => {
  return await xhr({
    url: '/b/getalltrails',
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

export const booktrailApi = {
  booktrail,
  getbooktraildata
};
